import type { PicotSpice } from "../types/api";
import { humanizeSpecialty } from "../utils/format";

interface StructuredQueryProps {
  framework: string | null;
  picot: PicotSpice | null;
  spice: PicotSpice | null;
  detectedDomains?: string[];
  complexity?: string | null;
  rewrittenQuery?: string | null;
  compact?: boolean;
}

const PICOT_KEYS = [
  ["P", "Population"],
  ["I", "Intervention"],
  ["C", "Comparison"],
  ["O", "Outcome"],
  ["T", "Timeframe"],
] as const;

const SPICE_KEYS = [
  ["S", "Setting"],
  ["P", "Perspective"],
  ["I", "Intervention"],
  ["C", "Comparison"],
  ["E", "Evaluation"],
] as const;

export function StructuredQuery({
  framework,
  picot,
  spice,
  detectedDomains = [],
  complexity,
  rewrittenQuery,
  compact,
}: StructuredQueryProps) {
  const fw = framework?.toUpperCase() ?? null;
  const slots = fw === "SPICE" ? SPICE_KEYS : PICOT_KEYS;
  const data = fw === "SPICE" ? spice : picot;

  if (!fw && !data) return null;

  return (
    <div className={`structured-query${compact ? " compact" : ""}`}>
      {fw ? <span className="framework-badge">{fw}</span> : null}
      <div className="slots-grid">
        {slots.map(([key, label]) => (
          <div key={key} className="slot-cell">
            <span className="slot-key">
              {key} · {label}
            </span>
            <span className="slot-val">{(data as Record<string, string | undefined>)?.[key] || "—"}</span>
          </div>
        ))}
      </div>
      {detectedDomains.length > 0 || complexity ? (
        <div className="classify-row">
          {detectedDomains.map((d) => (
            <span key={d} className="domain-chip">
              {humanizeSpecialty(d)}
            </span>
          ))}
          {complexity ? <span className="complexity-tag">complexity: {complexity}</span> : null}
        </div>
      ) : null}
      {rewrittenQuery && !compact ? (
        <p className="searched-as">
          Searched as: &ldquo;{rewrittenQuery}&rdquo;
        </p>
      ) : null}
    </div>
  );
}
